@if (showBanner | async) {
<div class="banner">Test-omgeving</div>
}
<router-outlet></router-outlet>
